import { useEffect, useState } from 'react';
import { Icon } from '@/design-system/ui/Icon';
import { cn } from '@/design-system/ui/cn';

/** Appears after the first screen of scrolling; sits above the mobile tab bar. */
export function ScrollTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="بازگشت به بالای صفحه"
      tabIndex={visible ? 0 : -1}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={cn(
        'fixed bottom-[calc(6.25rem+env(safe-area-inset-bottom))] left-4 z-30 grid size-11 place-items-center rounded-full bg-cta text-white shadow-floating transition duration-300 hover:brightness-110 active:scale-90 md:bottom-6 md:left-6',
        visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0',
      )}
    >
      <Icon name="arrowUp" size={22} />
    </button>
  );
}
